// 手机号码或固定电话
export function validatephonenumber(rule, value, callback) {
    let commonReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
    if (value === '' || value === undefined || value === null) {
        return callback(new Error('联系电话不能为空'))
    }
    if (commonReg.test(value)) {
        callback()
    } else {
        callback(new Error('请输入正确的手机号码'))
    }
}

// 判断输入的是正整数
export function isInteger(rule, value, callback) {
    if (!value) {
        return callback(new Error('授课人数不能为空'));
    }
    if (!Number(value)) {
        callback(new Error('请输入正整数'));
    } else {
        const re = /^[0-9]*[1-9][0-9]*$/; const rsCheck = re.test(value); if (!rsCheck) {
            callback(new Error('请输入正整数'));
        } else {
            callback();
        }
    }
}
